export default {
  itemsLimit: 1000,
}



// WEBPACK FOOTER //
// ../src/config.js